import type { IconProps as SvgIconProps } from '@tabler/icons-react'
import type { ComponentType, SVGProps } from 'react'
import type { IconName } from '#/k-icons'
import AlertSvg from '../../../svg-icons/alert.svg?react'
import AngleBarLeftSvg from '../../../svg-icons/angle-bar-left.svg?react'
import AngleBarRightSvg from '../../../svg-icons/angle-bar-right.svg?react'
import AngleDownSvg from '../../../svg-icons/angle-down.svg?react'
import AngleLeftSvg from '../../../svg-icons/angle-left.svg?react'
import AngleRightSvg from '../../../svg-icons/angle-right.svg?react'
import AngleUpSvg from '../../../svg-icons/angle-up.svg?react'
import ArchivedSvg from '../../../svg-icons/archived.svg?react'
import ArrowDownLeftSvg from '../../../svg-icons/arrow-down-left.svg?react'
import ArrowDownRightSvg from '../../../svg-icons/arrow-down-right.svg?react'
import ArrowDownSvg from '../../../svg-icons/arrow-down.svg?react'
import ArrowLeftSvg from '../../../svg-icons/arrow-left.svg?react'
import ArrowRightSvg from '../../../svg-icons/arrow-right.svg?react'
import ArrowUpLeftSvg from '../../../svg-icons/arrow-up-left.svg?react'
import ArrowUpRightSvg from '../../../svg-icons/arrow-up-right.svg?react'
import ArrowUpSvg from '../../../svg-icons/arrow-up.svg?react'
import AttachSvg from '../../../svg-icons/attach.svg?react'
import BlockSvg from '../../../svg-icons/block.svg?react'
import CaretDownSvg from '../../../svg-icons/caret-down.svg?react'
import CaretLeftSvg from '../../../svg-icons/caret-left.svg?react'
import CaretRightSvg from '../../../svg-icons/caret-right.svg?react'
import CaretUpSvg from '../../../svg-icons/caret-up.svg?react'
import CascadingSvg from '../../../svg-icons/cascading.svg?react'
import CheckCircleSvg from '../../../svg-icons/check-circle.svg?react'
import CheckSvg from '../../../svg-icons/check.svg?react'
import CloseSvg from '../../../svg-icons/close.svg?react'
import DataSyncSvg from '../../../svg-icons/data-sync.svg?react'
import DeploySvg from '../../../svg-icons/deploy.svg?react'
import DocumentSvg from '../../../svg-icons/document.svg?react'
import DownloadSvg from '../../../svg-icons/download.svg?react'
import DraftsSvg from '../../../svg-icons/drafts.svg?react'
import DragHandleSvg from '../../../svg-icons/drag-handle.svg?react'
import DuplicateSvg from '../../../svg-icons/duplicate.svg?react'
import EditSvg from '../../../svg-icons/edit.svg?react'
import EditorSvg from '../../../svg-icons/editor.svg?react'
import EmailSvg from '../../../svg-icons/email.svg?react'
import ExpandArrowSvg from '../../../svg-icons/expand-arrow.svg?react'
import ExpandListSvg from '../../../svg-icons/expand-list.svg?react'
import ExpandSvg from '../../../svg-icons/expand.svg?react'
import FigmaDataSync from '../../../svg-icons/figma-data-sync.svg?react'
import FigmaEyeOff from '../../../svg-icons/figma-eye-off.svg?react'
import FigmaMatrix from '../../../svg-icons/figma-matrix.svg?react'
import FigmaPublicCollection from '../../../svg-icons/figma-public-collection.svg?react'
import FigmaUnsubscribe from '../../../svg-icons/figma-unsubscribe.svg?react'
import FileAudioSvg from '../../../svg-icons/file-audio.svg?react'
import FileImageSvg from '../../../svg-icons/file-image.svg?react'
import FileVideoSvg from '../../../svg-icons/file-video.svg?react'
import FileXlsSvg from '../../../svg-icons/file-xls.svg?react'
import FileXmlSvg from '../../../svg-icons/file-xml.svg?react'
import FileSvg from '../../../svg-icons/file.svg?react'
import FilterArrowsSvg from '../../../svg-icons/filter-arrows.svg?react'
import FilterSvg from '../../../svg-icons/filter.svg?react'
import FlowsSvg from '../../../svg-icons/flows.svg?react'
import FolderInSvg from '../../../svg-icons/folder-in.svg?react'
import FolderOutSvg from '../../../svg-icons/folder-out.svg?react'
import FolderPlusSvg from '../../../svg-icons/folder-plus.svg?react'
import FolderPublicSvg from '../../../svg-icons/folder-public.svg?react'
import FolderSharedSvg from '../../../svg-icons/folder-shared.svg?react'
import FolderSubscribedSvg from '../../../svg-icons/folder-subscribed.svg?react'
import FolderSvg from '../../../svg-icons/folder.svg?react'
import FreezeSvg from '../../../svg-icons/freeze.svg?react'
import GallerySvg from '../../../svg-icons/gallery.svg?react'
import GlobeAltSvg from '../../../svg-icons/globe-alt.svg?react'
import GroupSplitSvg from '../../../svg-icons/group-split.svg?react'
import GroupSvg from '../../../svg-icons/group.svg?react'
import HeatmapSvg from '../../../svg-icons/heatmap.svg?react'
import HelpAcademySvg from '../../../svg-icons/help-academy.svg?react'
import HelpArticlesSvg from '../../../svg-icons/help-articles.svg?react'
import HelpForumSvg from '../../../svg-icons/help-forum.svg?react'
import HelpSvg from '../../../svg-icons/help.svg?react'
import HideSvg from '../../../svg-icons/hide.svg?react'
import InformationSvg from '../../../svg-icons/information.svg?react'
import IntercomSvg from '../../../svg-icons/intercom.svg?react'
import KoboSvg from '../../../svg-icons/kobo.svg?react'
import LanguageAltSvg from '../../../svg-icons/language-alt.svg?react'
import LanguageDefaultSvg from '../../../svg-icons/language-default.svg?react'
import LanguageSettingsSvg from '../../../svg-icons/language-settings.svg?react'
import LayerSvg from '../../../svg-icons/layer.svg?react'
import LibraryPublicSvg from '../../../svg-icons/library-public.svg?react'
import LibrarySvg from '../../../svg-icons/library.svg?react'
import LinkSvg from '../../../svg-icons/link.svg?react'
import LockAltSvg from '../../../svg-icons/lock-alt.svg?react'
import LockSvg from '../../../svg-icons/lock.svg?react'
import LogoGithubSvg from '../../../svg-icons/logo-github.svg?react'
import LogoInstagramSvg from '../../../svg-icons/logo-instagram.svg?react'
import LogoLinkedinSvg from '../../../svg-icons/logo-linkedin.svg?react'
import LogoTwitterSvg from '../../../svg-icons/logo-twitter.svg?react'
import LogoutSvg from '../../../svg-icons/logout.svg?react'
import MailSvg from '../../../svg-icons/mail.svg?react'
import MapViewSvg from '../../../svg-icons/map-view.svg?react'
import MediaFilesSvg from '../../../svg-icons/media-files.svg?react'
import MenuSvg from '../../../svg-icons/menu.svg?react'
import MinusSvg from '../../../svg-icons/minus.svg?react'
import MoreVerticalSvg from '../../../svg-icons/more-vertical.svg?react'
import MoreSvg from '../../../svg-icons/more.svg?react'
import NotificationSvg from '../../../svg-icons/notification.svg?react'
import PauseSvg from '../../../svg-icons/pause.svg?react'
import PdfSvg from '../../../svg-icons/pdf.svg?react'
import PinsSvg from '../../../svg-icons/pins.svg?react'
import PlaySvg from '../../../svg-icons/play.svg?react'
import PlusSvg from '../../../svg-icons/plus.svg?react'
import PrintSvg from '../../../svg-icons/print.svg?react'
import ProjectArchivedSvg from '../../../svg-icons/project-archived.svg?react'
import ProjectDeployedSvg from '../../../svg-icons/project-deployed.svg?react'
import ProjectDraftSvg from '../../../svg-icons/project-draft.svg?react'
import ProjectLockedSvg from '../../../svg-icons/project-locked.svg?react'
import ProjectOverviewSvg from '../../../svg-icons/project-overview.svg?react'
import ProjectSvg from '../../../svg-icons/project.svg?react'
import ProjectsSvg from '../../../svg-icons/projects.svg?react'
import QtAcknowledgeLockSvg from '../../../svg-icons/qt-acknowledge-lock.svg?react'
import QtAcknowledgeSvg from '../../../svg-icons/qt-acknowledge.svg?react'
import QtAreaLockSvg from '../../../svg-icons/qt-area-lock.svg?react'
import QtAreaSvg from '../../../svg-icons/qt-area.svg?react'
import QtAudioLockSvg from '../../../svg-icons/qt-audio-lock.svg?react'
import QtAudioSvg from '../../../svg-icons/qt-audio.svg?react'
import QtBackgroundAudioSvg from '../../../svg-icons/qt-background-audio.svg?react'
import QtBarcodeLockSvg from '../../../svg-icons/qt-barcode-lock.svg?react'
import QtBarcodeSvg from '../../../svg-icons/qt-barcode.svg?react'
import QtCalculateLockSvg from '../../../svg-icons/qt-calculate-lock.svg?react'
import QtCalculateSvg from '../../../svg-icons/qt-calculate.svg?react'
import QtDateLockSvg from '../../../svg-icons/qt-date-lock.svg?react'
import QtDateTimeLockSvg from '../../../svg-icons/qt-date-time-lock.svg?react'
import QtDateTimeSvg from '../../../svg-icons/qt-date-time.svg?react'
import QtDateSvg from '../../../svg-icons/qt-date.svg?react'
import QtDecimalLockSvg from '../../../svg-icons/qt-decimal-lock.svg?react'
import QtDecimalSvg from '../../../svg-icons/qt-decimal.svg?react'
import QtExternalXmlLockSvg from '../../../svg-icons/qt-external-xml-lock.svg?react'
import QtExternalXmlSvg from '../../../svg-icons/qt-external-xml.svg?react'
import QtFileLockSvg from '../../../svg-icons/qt-file-lock.svg?react'
import QtFileSvg from '../../../svg-icons/qt-file.svg?react'
import QtHiddenLockSvg from '../../../svg-icons/qt-hidden-lock.svg?react'
import QtHiddenSvg from '../../../svg-icons/qt-hidden.svg?react'
import QtLineLockSvg from '../../../svg-icons/qt-line-lock.svg?react'
import QtLineSvg from '../../../svg-icons/qt-line.svg?react'
import QtMetaDefaultSvg from '../../../svg-icons/qt-meta-default.svg?react'
import QtNoteLockSvg from '../../../svg-icons/qt-note-lock.svg?react'
import QtNoteSvg from '../../../svg-icons/qt-note.svg?react'
import QtNumberLockSvg from '../../../svg-icons/qt-number-lock.svg?react'
import QtNumberSvg from '../../../svg-icons/qt-number.svg?react'
import QtPhotoLockSvg from '../../../svg-icons/qt-photo-lock.svg?react'
import QtPhotoSvg from '../../../svg-icons/qt-photo.svg?react'
import QtPointLockSvg from '../../../svg-icons/qt-point-lock.svg?react'
import QtPointSvg from '../../../svg-icons/qt-point.svg?react'
import QtQuestionMatrixLockSvg from '../../../svg-icons/qt-question-matrix-lock.svg?react'
import QtQuestionMatrixSvg from '../../../svg-icons/qt-question-matrix.svg?react'
import QtRangeLockSvg from '../../../svg-icons/qt-range-lock.svg?react'
import QtRangeSvg from '../../../svg-icons/qt-range.svg?react'
import QtRankingLockSvg from '../../../svg-icons/qt-ranking-lock.svg?react'
import QtRankingSvg from '../../../svg-icons/qt-ranking.svg?react'
import QtRatingLockSvg from '../../../svg-icons/qt-rating-lock.svg?react'
import QtRatingSvg from '../../../svg-icons/qt-rating.svg?react'
import QtSelectManyFromFileLockSvg from '../../../svg-icons/qt-select-many-from-file-lock.svg?react'
import QtSelectManyFromFileSvg from '../../../svg-icons/qt-select-many-from-file.svg?react'
import QtSelectManyLockSvg from '../../../svg-icons/qt-select-many-lock.svg?react'
import QtSelectManySvg from '../../../svg-icons/qt-select-many.svg?react'
import QtSelectOneFromFileLockSvg from '../../../svg-icons/qt-select-one-from-file-lock.svg?react'
import QtSelectOneFromFileSvg from '../../../svg-icons/qt-select-one-from-file.svg?react'
import QtSelectOneLockSvg from '../../../svg-icons/qt-select-one-lock.svg?react'
import QtSelectOneSvg from '../../../svg-icons/qt-select-one.svg?react'
import QtTextLockSvg from '../../../svg-icons/qt-text-lock.svg?react'
import QtTextSvg from '../../../svg-icons/qt-text.svg?react'
import QtTimeLockSvg from '../../../svg-icons/qt-time-lock.svg?react'
import QtTimeSvg from '../../../svg-icons/qt-time.svg?react'
import QtVideoLockSvg from '../../../svg-icons/qt-video-lock.svg?react'
import QtVideoSvg from '../../../svg-icons/qt-video.svg?react'
import QuestionSvg from '../../../svg-icons/question.svg?react'
import ReloadSvg from '../../../svg-icons/reload.svg?react'
import ReplaceSvg from '../../../svg-icons/replace.svg?react'
import ReportsSvg from '../../../svg-icons/reports.svg?react'
import SearchSvg from '../../../svg-icons/search.svg?react'
import SettingsSvg from '../../../svg-icons/settings.svg?react'
import SkipLogicSvg from '../../../svg-icons/skip-logic.svg?react'
import SortAscendingSvg from '../../../svg-icons/sort-ascending.svg?react'
import SortDefaultSvg from '../../../svg-icons/sort-default.svg?react'
import SortDescendingSvg from '../../../svg-icons/sort-descending.svg?react'
import SparklesSvg from '../../../svg-icons/sparkles.svg?react'
import SpinnerSvg from '../../../svg-icons/spinner.svg?react'
import SpreadsheetSvg from '../../../svg-icons/spreadsheet.svg?react'
import StopSvg from '../../../svg-icons/stop.svg?react'
import SubscribeSvg from '../../../svg-icons/subscribe.svg?react'
import TableSvg from '../../../svg-icons/table.svg?react'
import TagSvg from '../../../svg-icons/tag.svg?react'
import TemplateLockedSvg from '../../../svg-icons/template-locked.svg?react'
import TemplateSvg from '../../../svg-icons/template.svg?react'
import TranscriptsSvg from '../../../svg-icons/transcripts.svg?react'
import TrashSvg from '../../../svg-icons/trash.svg?react'
import UnfreezeSvg from '../../../svg-icons/unfreeze.svg?react'
import UnsubscribeSvg from '../../../svg-icons/unsubscribe.svg?react'
import UploadSvg from '../../../svg-icons/upload.svg?react'
import UserShareSvg from '../../../svg-icons/user-share.svg?react'
import UserSvg from '../../../svg-icons/user.svg?react'
import UsersSvg from '../../../svg-icons/users.svg?react'
import ViewAllSvg from '../../../svg-icons/view-all.svg?react'
import ViewSvg from '../../../svg-icons/view.svg?react'
import WarningSvg from '../../../svg-icons/warning.svg?react'

export type LegacySvgIconComponent = ComponentType<SvgIconProps> & {
  isKoboLegacySvgIcon?: true
}

function wrapLegacySvgIcon(SvgComponent: ComponentType<SVGProps<SVGSVGElement>>): LegacySvgIconComponent {
  const LegacySvgIcon: LegacySvgIconComponent = function LegacySvgIcon({
    size,
    color,
    style,
    ...svgProps
  }: SvgIconProps) {
    const resolvedSize = typeof size === 'number' ? size : undefined
    const normalizedSvgProps = svgProps as unknown as SVGProps<SVGSVGElement>

    return (
      <SvgComponent
        {...normalizedSvgProps}
        height={resolvedSize}
        width={resolvedSize}
        style={{
          ...style,
          color,
          // This in theory is nice but we would need to set it to either fill:"currentColor" or stroke:"currentColor"
          // depending on what kind of SVG we have. We can't just set it to all of them
          // fill: 'currentColor',
        }}
      />
    )
  }

  LegacySvgIcon.isKoboLegacySvgIcon = true

  return LegacySvgIcon
}

export const LegacyIconToSvgComponentMap: Record<IconName, ComponentType<SvgIconProps>> = {
  alert: wrapLegacySvgIcon(AlertSvg),
  'angle-bar-left': wrapLegacySvgIcon(AngleBarLeftSvg),
  'angle-bar-right': wrapLegacySvgIcon(AngleBarRightSvg),
  'angle-down': wrapLegacySvgIcon(AngleDownSvg),
  'angle-left': wrapLegacySvgIcon(AngleLeftSvg),
  'angle-right': wrapLegacySvgIcon(AngleRightSvg),
  'angle-up': wrapLegacySvgIcon(AngleUpSvg),
  archived: wrapLegacySvgIcon(ArchivedSvg),
  'arrow-down': wrapLegacySvgIcon(ArrowDownSvg),
  'arrow-down-left': wrapLegacySvgIcon(ArrowDownLeftSvg),
  'arrow-down-right': wrapLegacySvgIcon(ArrowDownRightSvg),
  'arrow-left': wrapLegacySvgIcon(ArrowLeftSvg),
  'arrow-right': wrapLegacySvgIcon(ArrowRightSvg),
  'arrow-up': wrapLegacySvgIcon(ArrowUpSvg),
  'arrow-up-left': wrapLegacySvgIcon(ArrowUpLeftSvg),
  'arrow-up-right': wrapLegacySvgIcon(ArrowUpRightSvg),
  attach: wrapLegacySvgIcon(AttachSvg),
  block: wrapLegacySvgIcon(BlockSvg),
  'caret-down': wrapLegacySvgIcon(CaretDownSvg),
  'caret-left': wrapLegacySvgIcon(CaretLeftSvg),
  'caret-right': wrapLegacySvgIcon(CaretRightSvg),
  'caret-up': wrapLegacySvgIcon(CaretUpSvg),
  cascading: wrapLegacySvgIcon(CascadingSvg),
  check: wrapLegacySvgIcon(CheckSvg),
  'check-circle': wrapLegacySvgIcon(CheckCircleSvg),
  close: wrapLegacySvgIcon(CloseSvg),
  'data-sync': wrapLegacySvgIcon(DataSyncSvg),
  deploy: wrapLegacySvgIcon(DeploySvg),
  document: wrapLegacySvgIcon(DocumentSvg),
  download: wrapLegacySvgIcon(DownloadSvg),
  drafts: wrapLegacySvgIcon(DraftsSvg),
  'drag-handle': wrapLegacySvgIcon(DragHandleSvg),
  duplicate: wrapLegacySvgIcon(DuplicateSvg),
  edit: wrapLegacySvgIcon(EditSvg),
  editor: wrapLegacySvgIcon(EditorSvg),
  email: wrapLegacySvgIcon(EmailSvg),
  expand: wrapLegacySvgIcon(ExpandSvg),
  'expand-arrow': wrapLegacySvgIcon(ExpandArrowSvg),
  'expand-list': wrapLegacySvgIcon(ExpandListSvg),
  'figma-unsubscribe': wrapLegacySvgIcon(FigmaUnsubscribe),
  'figma-data-sync': wrapLegacySvgIcon(FigmaDataSync),
  'figma-eye-off': wrapLegacySvgIcon(FigmaEyeOff),
  'figma-matrix': wrapLegacySvgIcon(FigmaMatrix),
  'figma-public-collection': wrapLegacySvgIcon(FigmaPublicCollection),
  file: wrapLegacySvgIcon(FileSvg),
  'file-audio': wrapLegacySvgIcon(FileAudioSvg),
  'file-image': wrapLegacySvgIcon(FileImageSvg),
  'file-video': wrapLegacySvgIcon(FileVideoSvg),
  'file-xls': wrapLegacySvgIcon(FileXlsSvg),
  'file-xml': wrapLegacySvgIcon(FileXmlSvg),
  filter: wrapLegacySvgIcon(FilterSvg),
  'filter-arrows': wrapLegacySvgIcon(FilterArrowsSvg),
  flows: wrapLegacySvgIcon(FlowsSvg),
  folder: wrapLegacySvgIcon(FolderSvg),
  'folder-in': wrapLegacySvgIcon(FolderInSvg),
  'folder-out': wrapLegacySvgIcon(FolderOutSvg),
  'folder-plus': wrapLegacySvgIcon(FolderPlusSvg),
  'folder-public': wrapLegacySvgIcon(FolderPublicSvg),
  'folder-shared': wrapLegacySvgIcon(FolderSharedSvg),
  'folder-subscribed': wrapLegacySvgIcon(FolderSubscribedSvg),
  freeze: wrapLegacySvgIcon(FreezeSvg),
  gallery: wrapLegacySvgIcon(GallerySvg),
  'globe-alt': wrapLegacySvgIcon(GlobeAltSvg),
  group: wrapLegacySvgIcon(GroupSvg),
  'group-split': wrapLegacySvgIcon(GroupSplitSvg),
  heatmap: wrapLegacySvgIcon(HeatmapSvg),
  help: wrapLegacySvgIcon(HelpSvg),
  'help-academy': wrapLegacySvgIcon(HelpAcademySvg),
  'help-articles': wrapLegacySvgIcon(HelpArticlesSvg),
  'help-forum': wrapLegacySvgIcon(HelpForumSvg),
  hide: wrapLegacySvgIcon(HideSvg),
  information: wrapLegacySvgIcon(InformationSvg),
  intercom: wrapLegacySvgIcon(IntercomSvg),
  kobo: wrapLegacySvgIcon(KoboSvg),
  'language-alt': wrapLegacySvgIcon(LanguageAltSvg),
  'language-default': wrapLegacySvgIcon(LanguageDefaultSvg),
  'language-settings': wrapLegacySvgIcon(LanguageSettingsSvg),
  layer: wrapLegacySvgIcon(LayerSvg),
  library: wrapLegacySvgIcon(LibrarySvg),
  'library-public': wrapLegacySvgIcon(LibraryPublicSvg),
  link: wrapLegacySvgIcon(LinkSvg),
  lock: wrapLegacySvgIcon(LockSvg),
  'lock-alt': wrapLegacySvgIcon(LockAltSvg),
  'logo-github': wrapLegacySvgIcon(LogoGithubSvg),
  'logo-instagram': wrapLegacySvgIcon(LogoInstagramSvg),
  'logo-linkedin': wrapLegacySvgIcon(LogoLinkedinSvg),
  'logo-twitter': wrapLegacySvgIcon(LogoTwitterSvg),
  logout: wrapLegacySvgIcon(LogoutSvg),
  mail: wrapLegacySvgIcon(MailSvg),
  'map-view': wrapLegacySvgIcon(MapViewSvg),
  'media-files': wrapLegacySvgIcon(MediaFilesSvg),
  menu: wrapLegacySvgIcon(MenuSvg),
  minus: wrapLegacySvgIcon(MinusSvg),
  more: wrapLegacySvgIcon(MoreSvg),
  'more-vertical': wrapLegacySvgIcon(MoreVerticalSvg),
  notification: wrapLegacySvgIcon(NotificationSvg),
  pause: wrapLegacySvgIcon(PauseSvg),
  pdf: wrapLegacySvgIcon(PdfSvg),
  pins: wrapLegacySvgIcon(PinsSvg),
  play: wrapLegacySvgIcon(PlaySvg),
  plus: wrapLegacySvgIcon(PlusSvg),
  print: wrapLegacySvgIcon(PrintSvg),
  project: wrapLegacySvgIcon(ProjectSvg),
  'project-archived': wrapLegacySvgIcon(ProjectArchivedSvg),
  'project-deployed': wrapLegacySvgIcon(ProjectDeployedSvg),
  'project-draft': wrapLegacySvgIcon(ProjectDraftSvg),
  'project-locked': wrapLegacySvgIcon(ProjectLockedSvg),
  'project-overview': wrapLegacySvgIcon(ProjectOverviewSvg),
  projects: wrapLegacySvgIcon(ProjectsSvg),
  'qt-acknowledge': wrapLegacySvgIcon(QtAcknowledgeSvg),
  'qt-acknowledge-lock': wrapLegacySvgIcon(QtAcknowledgeLockSvg),
  'qt-area': wrapLegacySvgIcon(QtAreaSvg),
  'qt-area-lock': wrapLegacySvgIcon(QtAreaLockSvg),
  'qt-audio': wrapLegacySvgIcon(QtAudioSvg),
  'qt-audio-lock': wrapLegacySvgIcon(QtAudioLockSvg),
  'qt-background-audio': wrapLegacySvgIcon(QtBackgroundAudioSvg),
  'qt-barcode': wrapLegacySvgIcon(QtBarcodeSvg),
  'qt-barcode-lock': wrapLegacySvgIcon(QtBarcodeLockSvg),
  'qt-calculate': wrapLegacySvgIcon(QtCalculateSvg),
  'qt-calculate-lock': wrapLegacySvgIcon(QtCalculateLockSvg),
  'qt-date': wrapLegacySvgIcon(QtDateSvg),
  'qt-date-lock': wrapLegacySvgIcon(QtDateLockSvg),
  'qt-date-time': wrapLegacySvgIcon(QtDateTimeSvg),
  'qt-date-time-lock': wrapLegacySvgIcon(QtDateTimeLockSvg),
  'qt-decimal': wrapLegacySvgIcon(QtDecimalSvg),
  'qt-decimal-lock': wrapLegacySvgIcon(QtDecimalLockSvg),
  'qt-external-xml': wrapLegacySvgIcon(QtExternalXmlSvg),
  'qt-external-xml-lock': wrapLegacySvgIcon(QtExternalXmlLockSvg),
  'qt-file': wrapLegacySvgIcon(QtFileSvg),
  'qt-file-lock': wrapLegacySvgIcon(QtFileLockSvg),
  'qt-hidden': wrapLegacySvgIcon(QtHiddenSvg),
  'qt-hidden-lock': wrapLegacySvgIcon(QtHiddenLockSvg),
  'qt-line': wrapLegacySvgIcon(QtLineSvg),
  'qt-line-lock': wrapLegacySvgIcon(QtLineLockSvg),
  'qt-meta-default': wrapLegacySvgIcon(QtMetaDefaultSvg),
  'qt-note': wrapLegacySvgIcon(QtNoteSvg),
  'qt-note-lock': wrapLegacySvgIcon(QtNoteLockSvg),
  'qt-number': wrapLegacySvgIcon(QtNumberSvg),
  'qt-number-lock': wrapLegacySvgIcon(QtNumberLockSvg),
  'qt-photo': wrapLegacySvgIcon(QtPhotoSvg),
  'qt-photo-lock': wrapLegacySvgIcon(QtPhotoLockSvg),
  'qt-point': wrapLegacySvgIcon(QtPointSvg),
  'qt-point-lock': wrapLegacySvgIcon(QtPointLockSvg),
  'qt-question-matrix': wrapLegacySvgIcon(QtQuestionMatrixSvg),
  'qt-question-matrix-lock': wrapLegacySvgIcon(QtQuestionMatrixLockSvg),
  'qt-range': wrapLegacySvgIcon(QtRangeSvg),
  'qt-range-lock': wrapLegacySvgIcon(QtRangeLockSvg),
  'qt-ranking': wrapLegacySvgIcon(QtRankingSvg),
  'qt-ranking-lock': wrapLegacySvgIcon(QtRankingLockSvg),
  'qt-rating': wrapLegacySvgIcon(QtRatingSvg),
  'qt-rating-lock': wrapLegacySvgIcon(QtRatingLockSvg),
  'qt-select-many': wrapLegacySvgIcon(QtSelectManySvg),
  'qt-select-many-from-file': wrapLegacySvgIcon(QtSelectManyFromFileSvg),
  'qt-select-many-from-file-lock': wrapLegacySvgIcon(QtSelectManyFromFileLockSvg),
  'qt-select-many-lock': wrapLegacySvgIcon(QtSelectManyLockSvg),
  'qt-select-one': wrapLegacySvgIcon(QtSelectOneSvg),
  'qt-select-one-from-file': wrapLegacySvgIcon(QtSelectOneFromFileSvg),
  'qt-select-one-from-file-lock': wrapLegacySvgIcon(QtSelectOneFromFileLockSvg),
  'qt-select-one-lock': wrapLegacySvgIcon(QtSelectOneLockSvg),
  'qt-text': wrapLegacySvgIcon(QtTextSvg),
  'qt-text-lock': wrapLegacySvgIcon(QtTextLockSvg),
  'qt-time': wrapLegacySvgIcon(QtTimeSvg),
  'qt-time-lock': wrapLegacySvgIcon(QtTimeLockSvg),
  'qt-video': wrapLegacySvgIcon(QtVideoSvg),
  'qt-video-lock': wrapLegacySvgIcon(QtVideoLockSvg),
  question: wrapLegacySvgIcon(QuestionSvg),
  reload: wrapLegacySvgIcon(ReloadSvg),
  replace: wrapLegacySvgIcon(ReplaceSvg),
  reports: wrapLegacySvgIcon(ReportsSvg),
  search: wrapLegacySvgIcon(SearchSvg),
  settings: wrapLegacySvgIcon(SettingsSvg),
  'skip-logic': wrapLegacySvgIcon(SkipLogicSvg),
  'sort-ascending': wrapLegacySvgIcon(SortAscendingSvg),
  'sort-default': wrapLegacySvgIcon(SortDefaultSvg),
  'sort-descending': wrapLegacySvgIcon(SortDescendingSvg),
  sparkles: wrapLegacySvgIcon(SparklesSvg),
  spinner: wrapLegacySvgIcon(SpinnerSvg),
  spreadsheet: wrapLegacySvgIcon(SpreadsheetSvg),
  stop: wrapLegacySvgIcon(StopSvg),
  subscribe: wrapLegacySvgIcon(SubscribeSvg),
  table: wrapLegacySvgIcon(TableSvg),
  tag: wrapLegacySvgIcon(TagSvg),
  template: wrapLegacySvgIcon(TemplateSvg),
  'template-locked': wrapLegacySvgIcon(TemplateLockedSvg),
  transcripts: wrapLegacySvgIcon(TranscriptsSvg),
  trash: wrapLegacySvgIcon(TrashSvg),
  unfreeze: wrapLegacySvgIcon(UnfreezeSvg),
  unsubscribe: wrapLegacySvgIcon(UnsubscribeSvg),
  upload: wrapLegacySvgIcon(UploadSvg),
  user: wrapLegacySvgIcon(UserSvg),
  'user-share': wrapLegacySvgIcon(UserShareSvg),
  users: wrapLegacySvgIcon(UsersSvg),
  view: wrapLegacySvgIcon(ViewSvg),
  'view-all': wrapLegacySvgIcon(ViewAllSvg),
  warning: wrapLegacySvgIcon(WarningSvg),
} satisfies Record<IconName, ComponentType<SvgIconProps>>

export function resolveLegacySvgIconByName(iconName: IconName): ComponentType<SvgIconProps> {
  return LegacyIconToSvgComponentMap[iconName]
}
